import { SalesOrderStatus } from '../constants/sales-order-status.js';
/** Statuses where `cancelSalesOrder` refuses (N8, X-5); Cancelled is absent as a repeat cancel is a no-op (N15). */
export const BLOCKED_SALES_ORDER_CANCEL_STATUSES = [
    SalesOrderStatus.SHIPPED,
    SalesOrderStatus.COMPLETE,
    SalesOrderStatus.REJECTED,
];
//# sourceMappingURL=blocked-cancel-statuses.js.map